module.exports = __webpack_public_path__ + "img/TeamComic_062.c3811315.png";